import { redirect } from 'react-router';
import { publicAction } from '@/data/loaders';

export function updateProfile(params) {
  return publicAction("updateProfile", params, { allowIncompleteUserdata: true })
}

export function loadEmailPreferencesFromToken({ request }) {
  return new Promise(function (resolve, reject) {
    const url = new URL(request.url);
    const token = url.searchParams.get("token");

    publicAction("getEmailPreferencesByToken", { token }, { unauthenticated: true }).then(function ({ data }) {
      resolve({ token, value: data });
    }).catch(function (error) {
      if (error?.status === 400 || error?.status === 404) {
        resolve({});
      } else {
        reject(error);
      }
    });
  });
}

export function getMyOrganizationDepartments() {
  return publicAction("getMyOrganizationDepartments", {}, { allowIncompleteUserdata: true })
}

export function requestToJoinDepartment({ id }) {
  return publicAction("requestToJoinDepartment", { id }, { allowIncompleteUserdata: true })
}

export function loadSettings({request}) {
  return new Promise(function (resolve) {
    if (request.url.endsWith("/settings") || request.url.endsWith("/settings/")) {
      resolve(redirect("/settings/profile"));
    } else {
      resolve({});
    }
  })
}